const state = {
  isLoading: true, // 是否显示加载中，默认为限制loading，显示时值为true
  isDisabled: false, // 是否禁用下拉刷新,默认为开启,开启值为false
  excelJson: {} // 文件转化为json以后的数据
}
export default state
